var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNisantepe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.3,14c-1.8.6-2.4,1.9-2.7,3.3-.4,2.3-1.9,3.5-3.9,4-2.1.5-2.5,1.2-2.8,3.5-.4,3.8-4.7,8.8-8.4,9.8-1.1.3-2.2.2-3.3,0-1.4-.2-2.9-.3-4.3.2-.6.2-1,0-1.2-.6-.5-1.2-.5-2.5-.5-3.8,0-.4,0-1-.4-1.2-.5-.2-.8.1-1.1.4-.4.3-.8.5-1,0-.5-1.2-1.4-.9-2.3-.8-1.4.2-1.6,0-1.7-1.3-.2-2.2-.1-4.4,1.4-5.9,1.1-1,1.7-2.3,2.7-3.4.6-.6,1.5-.8,2.3-.3,1.8,1.2,4.1,1.4,5.9,2.8,2.1,1.7,4.3.7,6.4-.4.5-.2.9-.6,1.4-.9.9-.5,1.3-1.3,1-2.3-.3-1.3-.1-2.4.4-3.6,1.3-2.7,1-5.6.2-8.4-.3-1.1-.5-2.2.2-3.2.2-.3.1-.7.1-1.1,0-.3-.3-.6,0-.8.3-.2.6,0,.8.2.4.2.4.5.3.8-.3.8-.6,1.5-.7,2.4,0,2.1.8,3.9,1.8,5.6.4.7.9,1.4.6,2.3-.2.7.2,1.1.9,1,1.5-.1,2.9.4,4.4,0,1.3-.3,2,.9,3.2,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNisantepe);
export default __webpack_public_path__ + "static/media/nisantepe.4855bb46c6db32ed4b6624788149807d.svg";
export { ForwardRef as ReactComponent };